export default "__VITE_ASSET__BBBu8JTj__"